export default __webpack_public_path__ + "static/media/support-org4.0247c293.png";